import { render, staticRenderFns } from "./BoletimMedicaoCronogramaTable.vue?vue&type=template&id=5b10a537&scoped=true&"
import script from "./BoletimMedicaoCronogramaTable.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoCronogramaTable.vue?vue&type=script&lang=js&"
import style0 from "./BoletimMedicaoCronogramaTable.vue?vue&type=style&index=0&id=5b10a537&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10a537",
  null
  
)

export default component.exports